import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined';
import AdjustOutlinedIcon from '@material-ui/icons/AdjustOutlined';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import { createUploadState, uploadSelectedFile } from '../../../../helpers/attachment-helper';
import CustomSelect from '../custom-select';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
const RegistrationDialog = ({ handleReloadOffers, reservationReqId }) => {
    const classes = useStyles();
    const [destination, setDestination] = useState(null);
    const [error, setError] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [attachmentUpload, setAttachmentUpload] = useState(createUploadState());

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/destination", { headers: headers })
            .then(res => { setDestination(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, []);

    const handleAttachmentChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "registration",
            token: user.Token,
            setUploadState: setAttachmentUpload
        });
    };

    const submitOffer = (event) => {
        event.preventDefault();
        setLoader(true);
        setError(null);
        let visaInputs = event.target.querySelectorAll('input');
        let visaTextArea = event.target.querySelectorAll('textarea');
        let attachmentInput = event.target.querySelector(`#file-0`);

        if (attachmentUpload.uploading) {
            setError("Attachment upload is still in progress.");
            setLoader(false);
            return;
        }

        if (attachmentInput.files.length > 0 && !attachmentUpload.blobPath) {
            setError(attachmentUpload.error || "Upload the attachment before submitting the offer.");
            setLoader(false);
            return;
        }

        let registrationOfferResource = new FormData();
        
        registrationOfferResource.append("ReservationReqId", reservationReqId);
        registrationOfferResource.append("OfferHeadline", event.target.querySelector("#hd-ln").value);
        registrationOfferResource.append("DestinationId", parseInt(visaInputs[1].value));
        registrationOfferResource.append("RegistrationType", visaInputs[4].value);
        registrationOfferResource.append("RegistrationPrice", parseInt(visaInputs[3].value));
        registrationOfferResource.append("RegistrationDueDate", visaInputs[2].value);
        registrationOfferResource.append("AttachmentFile", attachmentUpload.blobPath ? attachmentUpload.blobPath : "");
        registrationOfferResource.append("RegistrationRequirements", visaTextArea[0].value);
        registrationOfferResource.append("Notes", visaTextArea[1].value);
        const config = {
            headers: {
                "Authorization": `Bearer ${user.Token}`,
                "Accept": "application/json",
                'content-type': 'multipart/form-data',
                "Content-Encoding": "gzip"
            }
        };

        axios.post("/api/registrationoffer", registrationOfferResource, config)
            .then(res => {
                setSuccess(true);
                setTimeout(() => {
                    setLoader(false);
                    handleReloadOffers();
                }, 750);
            })
            .catch(err => {
                let errorMsg = "Error Adding Offer — Try again later!";
                if (err.response && err.response.data) {
                    const data = err.response.data;
                    if (data.errors) {
                        errorMsg = Object.values(data.errors).flat().join(" | ");
                    } else if (typeof data === "string") {
                        errorMsg = data;
                    }
                }
                setServerError(errorMsg);
                setSuccess(false);
                setTimeout(() => setLoader(false), 750);
            });

    }

    return (
        <>
            <Backdrop className={classes.backdrop} open={loader} style={{ zIndex: `2000` }}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <form onSubmit={submitOffer}>
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="hd-ln"
                            label={"Offer Headline"}
                            helperText={"Write an uniqe/request offer headline. Recommended to contain your company name and the word 'registration'(ex: CoolCompany Registration Offer 1)"}
                            fullWidth
                            type={"text"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ViewHeadlineOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                            required
                        />
                    </Grid>
                </Grid>
                {
                    destination ?
                        <RegistrationRow
                            index={0}
                            destination={destination}
                            attachmentUpload={attachmentUpload}
                            onAttachmentChange={handleAttachmentChange}
                        />
                        :null
                }
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12} sm={6}>
                        {
                            typeof error === "string" ?
                                <Alert variant="filled" severity="error">{error}</Alert>
                                : null
                        }
                        {
                            success === false ?
                                <Alert variant="filled" severity="error">Error Adding Offer — {serverError}</Alert>
                                : null
                        }
                        {
                            success === true ?
                                <Alert variant="filled" severity="success">Offer Added Successfully</Alert>
                                : null
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                        >
                            Submit Offer
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

const RegistrationRow = ({ index, destination, attachmentUpload, onAttachmentChange }) => {
    const [_index] = useState(index);
    const [_destination] = useState(destination);
    return (
        <>
            <Grid container item xs={12} spacing={2}>
                <Grid item sm={4} md={4} lg={2}>
                    <CustomSelect
                        data={_destination}
                        label={"Destination"}
                        required={true}
                        icon={<ExploreOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={2}>
                    <TextField
                        label={"Due Date"}
                        fullWidth
                        type={"date"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EventOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={2}>
                    <TextField
                        label={"Price"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalAtmIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={8} md={8} lg={4}>
                    <TextField
                        label={"Registration Type"}
                        fullWidth
                        type={"text"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AdjustOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={2}>
                    <input
                        accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                        style={{ display: `none` }}
                        id={`file-${_index}`}
                        type="file"
                        onChange={onAttachmentChange}
                    />
                    <label htmlFor={`file-${_index}`}>
                        <Button variant="outlined" color="primary" component="span">
                            Attachment
                        </Button>
                    </label>
                    {
                        attachmentUpload.uploading ?
                            <div style={{ marginTop: "8px" }}>Uploading attachment...</div>
                            : null
                    }
                    {
                        attachmentUpload.originalFileName ?
                            <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div>
                            : null
                    }
                </Grid>

                <Grid item sm={12} md={6} lg={6}>
                    <TextField
                        label="Requirements"
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6}>
                    <TextField
                        label="Notes"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default RegistrationDialog;
